const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get("lang") ? urlParams.get("lang") : "es";
const indonesia = urlParams.get("indonesia") ? urlParams.get("indonesia") : "false";
export const inDevMode = process.env.NODE_ENV === "development";
const DistributorsTitleES = "Distribuidores online";
const DistributorsTitleCA = "Distribuïdors online";
const DistributorsTitleEN = "Online distributors";
const DistributorsTitleFR = "Distributeurs online";
const DistributorsTitleIT = "Distributori on-line";
const isPre = false;
const urlShad = isPre ? "https://preprod.shad.es" : "https://www.shad.es";
let DistributorsItemsURL = urlShad + "/assets/json/distributors.json";
let DistributorsItems = [];
export let MarkersURL = lang === 'en-id' && indonesia ? urlShad + "/assets/json/clients_data_indo.json" : urlShad + "/assets/json/clients_data.json";
if (inDevMode) {
    MarkersURL = "http://localhost:3000/app-donde-comprar/clients_data.json";
    DistributorsItemsURL = "http://localhost:3000/app-donde-comprar/distributors.json";
}

if (DistributorsItemsURL && DistributorsItemsURL.length > 0) {
    try {
        const responseDistributors = await fetch(DistributorsItemsURL);
        DistributorsItems = await responseDistributors.json();
    } catch(err) {
        console.log(err);
    }
}

let DistributorsTitle = "";

if (lang === "es") {
    DistributorsTitle = DistributorsTitleES;
} else if (lang === "ca") {
    DistributorsTitle = DistributorsTitleCA;
} else if (lang === "it") {
    DistributorsTitle = DistributorsTitleIT;
} else if (lang === "fr") {
    DistributorsTitle = DistributorsTitleFR;
} else {
    DistributorsTitle = DistributorsTitleEN;
}

export { DistributorsTitle };
export { DistributorsItems };
// Si pones el polygon es mas exacto e ignora el lat y lng (Osea lo haces o por radio o por polygon), no tengo los polygon simplificados asi que no puedo hacerlo por polygon que seria lo ideal
export const zoneRadios = {
    "DE": { 
        lat: 51.1657,
        lng: 10.4515,
        radius: 350000, // 350 km en metros
        usePolygon: false,
        polygon: [
        ],
        debugPolygon: true,
        debugPolygonColor: "rgba(223, 53, 26, 0.8)",
    },
    "AT": {
        lat: 47.70,
        lng: 13.35,
        radius: 320000, // 320 km en metros
        usePolygon: false,
        polygon: [
          ],
          debugPolygon: true,
          debugPolygonColor: "rgba(23, 24, 134, 0.8)",
    },
    "CH": {
        lat: 46.80,
        lng: 8.23,
        radius: 115000, // 115 km en metros
        usePolygon: false,
        polygon: [
        ],
        debugPolygon: true,
        debugPolygonColor: "rgba(28, 139, 25, 0.8)",
    }
}